import React, { Component } from 'react'
import apiService from '../../services/ApiService'
import Select from 'react-select'

class EntityStatus extends Component {
    constructor() {
        super()
        this.state = {
            entityStatusList: "",
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getEntyStatusList(this.props.type)
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getEntyStatusList = (type) => {
        apiService.getEntyStatusList(type)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        entityStatusList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}

        
             list = Object.keys(this.state.entityStatusList).map((value,index) => {            
                    return {
                        label : this.state.entityStatusList[value],
                        value : this.state.entityStatusList[value]
                    }
            })
           

        
        list.sort((a,b) => a.label.localeCompare(b.label));

          if((this.props.removeInTransist && this.props.removeInTransist==="YES") || (this.props.removeInHired && this.props.removeInHired==="YES")){
                 list.map(function(item,index) {
                    if (item['label'] === "IN TRANSIT" || item['label'] === "HIRED") {
                        if (index > -1) {
                            list.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    }
                    return true
                });
             }

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Status"
                options={list}
                onChange={(e) => { (e) ? this.props.entityStatusChange(e) : this.props.entityStatusChange([])}}
                />
            </div>
        )
    }
}
export default EntityStatus


// WEBPACK FOOTER //
// ./src/common/DropDowns/EntityStatus.js